/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AttachFile/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import ButtonSolid from 'DesignSystem/ButtonSolid/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AttachFile({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/Preview/Content/AttachFile"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="AttachFile.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ButtonSolid
  viewPath={`${viewPath}/ButtonSolid`}
 borderBottomRightRadius={5}
 borderTopRightRadius={5}
 borderBottomLeftRadius={5}
 borderTopLeftRadius={5}
 paddingBottom={14}
 paddingLeft={24}
 paddingRight={24}
 paddingTop={14}
 text="Attach file"
 onClick={onClick}
/>
</div>
{children}
</React.Fragment>)
}